/* External */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

/* Ott */
import Rating from '@dtvgo/rating';

/* Utils */

/* Styles */
import './AgeRatingProgressSteps.scss';
import FocusableAgeRating from './BaseFocusableAgeRating';

function AgeRatingProgressSteps({
  isBrazil,
  activeStep,
  setActiveStep,
  setAgeRatingLabel,
  ageRatingData,
  ageRatingLabels,
  isAgeRatingForWeb,
  realFocusKey,
  setFocus,
}) {
  const steps = Object.entries(ageRatingData).map(([step, rating]) => ({
    label: (
      <div className={`age-step ${step === '3' ? 'age-step-set-color' : ''}`}>
        <Rating
          rating={rating === '0' ? 'L' : rating}
          brazil={isBrazil}
          className="step-classification"
        />
        {isBrazil && (
          <Rating
            rating={rating === '0' ? 'AL' : `A${rating}`}
            brazil={isBrazil}
            className="step-classification"
          />
        )}
        {!isAgeRatingForWeb && <span className="step-label">{ageRatingLabels[rating]}</span> }
      </div>
    ),
    step: Number.parseInt(step, 10),
    rating,
    labelRating: ageRatingLabels[rating],
  }));
  const [changeActiveStep, setChangeActiveStep] = useState(activeStep);
  const [width, setWidth] = useState();
  const [height, setheight] = useState();
  const AgeRatingItemFocusKey = `${realFocusKey}-focus-age-rating-1`;

  useEffect(() => {
    setFocus(AgeRatingItemFocusKey);
  }, [AgeRatingItemFocusKey, setFocus]);

  useEffect(() => {
    const totalSteps = steps.length;
    if (!isAgeRatingForWeb) {
      setheight(`${(90 / (totalSteps - 1)) * (changeActiveStep - 1)}%`);
    }
    setWidth(`${(100 / (totalSteps - 1)) * (changeActiveStep - 1)}%`);
  }, [changeActiveStep, steps.length, isAgeRatingForWeb]);

  // Some styles that need JS for dinamic
  const styleAfter = { width };
  const styleheight = { height };
  const stepStatus = (step) => ((step > changeActiveStep) ? 'non-active-step' : 'active-step');

  function styleStep() {
    return {
      borderWidth: `${isAgeRatingForWeb ? '2' : '4'}px`,
      borderStyle: 'solid',
    };
  }

  function changeClassification(step, labelRating) {
    setChangeActiveStep(step);
    setActiveStep(step);
    setAgeRatingLabel(labelRating);
  }

  return (
    <div>
      {isAgeRatingForWeb ? (
        <div className="age-rating-steps-web">
          <div className="age-rating-steps-web__container">
            <span className="age-rating-steps-web__container-steps" style={styleAfter} />
            {steps.map(({ step, label, labelRating }) => (
              <button type="button" key={step} onClick={() => changeClassification(step, labelRating)} className="age-rating-steps-web__container-wrapper">
                <div className={`age-rating-steps-web__container-background ${stepStatus(step)}`} style={styleStep()}>
                  {step <= changeActiveStep && <div className="age-rating-steps-web__container-circle" /> }
                </div>
                <div className="age-rating-steps-web__container-label-container">
                  {label}
                </div>
              </button>
            ))}
          </div>
        </div>
      ) : (
        <div className="age-rating-steps-html5">
          <div className="age-rating-steps-html5__container">
            <span className="age-rating-steps-html5__container-steps" style={styleheight} />
            {steps.map(({
              step,
              label,
              rating,
              labelRating,
            }) => (
              <FocusableAgeRating
                focusKey={`${realFocusKey}-focus-age-rating-${step}`}
                onEnterPress={() => changeClassification(step, labelRating)}
                label={label}
                key={rating}
                styleStep={styleStep()}
                className={stepStatus(step)}
                changeActiveStep={changeActiveStep}
                step={step}
                focused
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

AgeRatingProgressSteps.propTypes = {
  isBrazil: PropTypes.bool,
  activeStep: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  setActiveStep: PropTypes.func,
  setAgeRatingLabel: PropTypes.func,
  ageRatingData: PropTypes.shape({}),
  ageRatingLabels: PropTypes.shape({}),
  isAgeRatingForWeb: PropTypes.bool,
  realFocusKey: PropTypes.string,
  setFocus: PropTypes.func,
};

AgeRatingProgressSteps.defaultProps = {
  isBrazil: false,
  activeStep: 1,
  setActiveStep: undefined,
  setAgeRatingLabel: undefined,
  ageRatingData: {},
  ageRatingLabels: {},
  isAgeRatingForWeb: false,
  realFocusKey: '',
  setFocus: undefined,
};

export default AgeRatingProgressSteps;
